import { render, staticRenderFns } from "./AffiliateShareUrl.vue?vue&type=template&id=b8fc1f44&"
import script from "./AffiliateShareUrl.vue?vue&type=script&lang=js&"
export * from "./AffiliateShareUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports